import { Modal, Form, Select, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useAuth } from '../../../../../../store/AuthContext/AuthContext';
import { authFetch } from '../../../../../../common/request/authFetch';
import { PREDEFINED_REPORTS } from '../../../../menuUsers/reports/ReportTypes';
import { useFetch } from '../../../../../../hooks/useFetch/useFetch';
import { DrawerPanelTitle, modalPanelStyles } from '../../../../common/Drawers/DrawerPanelTitle';

export const AddReportDefinitionModal = (props: { onFinish: any, onChange: any }) => {
    
    const [scheduledReports, setScheduledReports] = useState<any>(null);
    const [form] = Form.useForm();
    const { t } = useTranslation();
    const [updateData, setUpdateData] = useState(false);          
    const { projectGroup } = useAuth();    
    
    const reportOptions = Array.isArray(scheduledReports)
        ? [
            {
                label: 'Informes de proyecto',
                options: scheduledReports
                    .filter((reportKey: string) => PREDEFINED_REPORTS[reportKey]?.scope === 'PROJECT')
                    .map((reportKey: string) => ({
                        value: reportKey,
                        label: PREDEFINED_REPORTS[reportKey]?.name || reportKey,
                    })),
            },
            {
                label: 'Informes por local',
                options: scheduledReports
                    .filter((reportKey: string) => PREDEFINED_REPORTS[reportKey]?.scope === 'LOCATION')
                    .map((reportKey: string) => ({
                        value: reportKey,
                        label: PREDEFINED_REPORTS[reportKey]?.name || reportKey,
                    })),
            },
          ].filter((group) => group.options.length > 0)
        : [];
    
    useFetch(
        `${process.env.REACT_APP_API}/projects/${projectGroup.project}/report-types` ,
        {},
        [updateData],
        (data) => {
            setScheduledReports(data);          
        }
    );

    const onFormFinish = async (values: any) => {
        const data = {
            ...values,
        };

        await authFetch(`${process.env.REACT_APP_API}/projects/` + projectGroup.project + '/scheduledReports', { method: 'POST', data })
        .then((res) => { 
            if (res) { 
                setUpdateData(!updateData) 
                props.onChange();
            } else {
                message.error('Error inesperado', 3)
            }
        });
    }    

    return (
        <Modal
            open={true}
            onOk={() => form.submit()}
            onCancel={props.onFinish}
            afterClose={form.resetFields}
            {...modalPanelStyles}
            title={<DrawerPanelTitle title="Añadir informe" />}
        >
            <Form layout='vertical' form={form} onFinish={onFormFinish}>
                                
                <Form.Item 
                    rules={[{ required: true, message: 'Por favor, selecciona un tipo de informe' }]} 
                    name="type" 
                    label='Tipo de Informe'
                >
                    <Select 
                        placeholder="Selecciona un tipo de informe..."
                        options={reportOptions} // Ahora usa las opciones filtradas por la API
                        loading={scheduledReports === null} // Muestra un spinner mientras carga la API
                        showSearch
                        filterOption={(input, option) =>
                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                        }
                    />
                </Form.Item>
                
            </Form>         
        </Modal>
    );
};